module.exports = __webpack_public_path__ + "img/bad-vertical-stairs.51e35215.gif";